<template>
  <div>
    <header-vue ref="myHeader" />
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view
        :key="key"
        @myChange="myChange"
      />
    </transition>
    <footer-vue v-if="key !== '/xyd/welcome' && key !== '/xyd/login'" />
  </div>
</template>

<script>
import HeaderVue from "./Header";
import FooterVue from "./Footer";
export default {
  components: { HeaderVue, FooterVue },
  computed: {
    key () {
      return this.$route.path;
    }
  },
  methods: {
    myChange () {
      this.$refs["myHeader"].myChange();
    }
  }
}
</script>

<style lang="less" scoped>
.mainWrapperOuter {
  width: 100%;
  color: #2a2a2a;
  box-sizing: border-box;
  // user-select: none;
  .headerBg {
  }
}
</style>
